import React from 'react';
import '../styles/ResidentialPage.css';

const ResidentialPage = () => {
  const services = [
    {
      title: "Standard Home Cleaning",
      price: "125.00",
      duration: "2-3 Hour Cleanings",
      durationNote: "(estimated)",
      features: [
        "Complete Dusting Ceiling to Floors",
        "Sweeping, Mopping, Vacuuming",
        "Full Cleaning of Bathrooms"
      ],
      image: require('../assets/standard-cleaning.jpg')
    },
    {
      title: "Deep Home Cleaning",
      price: "200.00",
      duration: "3-4 Hour Cleanings",
      durationNote: "(estimated)",
      features: [
        "Scrubbing of Tile & Grout",
        "Windows & Windowsill Cleaning",
        "Cleaning of Baseboards & Walls"
      ],
      image: require('../assets/deep-cleaning.jpg')
    },
    {
      title: "Move In/Out Cleaning",
      price: "250.00",
      duration: "5-6 Hour Cleanings",
      durationNote: "(estimated)",
      features: [
        "Appliance Cleaning Inside / Out",
        "Basement & Garage Sweeping",
        "Inside Cabinets & Drawer Cleaning"
      ],
      image: require('../assets/move-cleaning.jpg')
    }
  ];

  return (
    <div className="residential-page">
      {/* Hero Section */}
      <section className="residential-hero">
        <div className="hero-content">
          <h1>Professional Home Cleaning Services</h1>
          <p>Experience the comfort of a spotlessly clean home. Our trusted professionals deliver exceptional results every time.</p>
        </div>
      </section>

      {/* Popular Services Section */}
      <section className="services-section">
        <div className="section-header">
          <h2>Our Most Popular Cleaning Services</h2>
          <p>We are here to change the image of cleaning companies by offering fast convenient services for customers of all sizes.</p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-header">
                <span className="service-type">{service.title}</span>
                <div className="price-block">
                  <span className="starting-at">Starting At:</span>
                  <span className="price">${service.price}</span>
                </div>
              </div>

              <div className="duration-banner">
                {service.duration} <span className="duration-note">{service.durationNote}</span>
              </div>

              <div className="service-image">
                <img src={service.image} alt={service.title} />
              </div>

              <div className="service-features">
                {service.features.map((feature, idx) => (
                  <div key={idx} className="feature-item">
                    <span className="checkmark">✓</span>
                    {feature}
                  </div>
                ))}
              </div>

              <button className="get-quote-button">GET A QUOTE</button>
            </div>
          ))}
        </div>

        <div className="book-online-container">
          <button className="book-online-button">BOOK ONLINE NOW</button>
        </div>
      </section>
    </div>
  );
};

export default ResidentialPage; 